var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-form',{attrs:{"id":_vm.id,"type":"course","plural":"courses"},model:{value:(_vm.course),callback:function ($$v) {_vm.course=$$v},expression:"course"}})}
var staticRenderFns = []

export { render, staticRenderFns }